/* generated by pull.js */
const manifest = {
  "noTranslations": true,
  "name": "Hide Logo",
  "description": "Hides a logo in the menu bar. Based on DinosaurMod's Hide Logo addon.",
  "tags": [
    "theme",
    "new",
    "pot"
  ],
  "credits": [
    {
      "name": "GaiaWindWave90",
      "link": "https://scratch.mit.edu/users/kinetaV/"
    }
  ],
  "enabledByDefault": false,
  "dynamicDisable": false,
  "userstyles": [
    {
      "url": "hide-logo.css"
    }
  ]
};
export default manifest;
